export { default } from "./ImageConfig";
